import { gql } from '@apollo/client'
import { getChildElementQuery } from '../queries/projectElements.queries'

const elements = getChildElementQuery(3)

export const SetManufacturerProductListingIsSelectedMutation = gql`
    mutation setManufacturerProductListingIsSelected(
        $input: ToggleManufacturerInput!
    ) {
        setManufacturerProductListingIsSelected(input: $input){
            id
            ${elements}
            comments
            textType
            isBestPractice
            isGlobalBestPractice
        }
    }
`
export const SetManufacturerProductListingIsSelectedMutationForImportedPT = gql`
    mutation setImportedManufacturer(
        $input: ToggleImportedManufacturerInput!
    ) {
        setImportedManufacturer(input: $input){
            id
            ${elements}
            comments
            textType
        }
    }
`

export const AddManufacturerProductListingElementsMutation = gql`
    mutation addManufacturerProductListingElements(
        $input: CreateProjectManufacturerProductListingInput!
    ) {
        addManufacturerProductListingElements(input: $input) {
            updatedInput {
                projectElementType
                elementId
                productFamilyId
                projectNuggetId
                assemblyId
                projectId
                listingId
                type
                firmName
                productName
                productType
                isBOD
                isAddMasterSpecAndManufacturerOptions
                displayTextFormat
                ptpOptionsToInclude
            }
            projectElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBpPublished
                isBasedFromManufacturerOption
                attachedToFirmId
                isFromPPLTemplate
                isPPLProductType
                isMasterSpecClone
                isSpecTextNode
                importedByInfo {
                    importDate
                    importedBy {
                        userFullName
                    }
                }
                iteration {
                    id
                    name
                }
            }
        }
    }
`

export const AddManufacturerProductListingInProjectMutation = gql`
    mutation addManufacturerProductListingInProject(
        $input: CreateProjectManufacturerProductListingInput!
    ) {
        addManufacturerProductListingInProject(input: $input) {
            id
            ${elements}
            comments
            textType
        }
    }
`
export const ToggleMultipleManufacturerSelectionsMutation = gql`
    mutation toggleMultipleManufacturerSelections(
        $input: ToggleMultipleManufacturersInput!
    ) {
        toggleMultipleManufacturerSelections(input: $input) {
            contentItems {
                id
                contentType
                textType
            }
            updatedElementId
            projectElementNodes {
                id
                elementId
                baseElementId
                nodeOrder
                isInProject
                isDeactivated
                elementType
                text
                treePath
                parentNodeId
                projectId
                isHidden
                parentTreePath
                isSearchResult
                hasChildren
                isLastSubAssembly
                isBestPractice
                isGlobalBestPractice
                hasBestPractice
                isImportedToProject
                importedToProjectId
                isBasedFromImportedNode
                isProjectOnly
                isBpPublished
                isBasedFromManufacturerOption
                attachedToFirmId
                isFromPPLTemplate
                isPPLProductType
                isMasterSpecClone
                isSpecTextNode
                importedByInfo {
                    importDate
                    importedBy {
                        userFullName
                    }
                }
                iteration {
                    id
                    name
                }
            }
        }
    }
`
export const SetProjectManufacturerProductListingAsBODMutation = gql`
    mutation setProjectManufacturerProductListingAsBOD (
        $input: CreateProjectManufacturerProductListingInput!
    ) {
        setProjectManufacturerProductListingAsBOD(input: $input) {
            id
            ${elements}
            comments
            textType
        }
    }
`
export const DeleteProjectManufacturerProductListingMutation = gql`
    mutation deleteProjectManufacturerProductListing(
        $input: DeleteProjectManufacturerProductListingInput!
    ) {
        deleteProjectManufacturerProductListing(input: $input) {
            id
            ${elements}
            comments
            textType
        }
    }
`

export const InsertCustomManufacturerInProductListingMutation = gql`
    mutation insertCustomManufacturerInProductListing(
        $input: InsertCustomManufacturerInput!
    ) {
        insertCustomManufacturerInProductListing(input: $input) {
            id
            ${elements}
        }
    }
`

export const DeleteUserAddedManufacturerMutation = gql`
    mutation deleteProductListing($input: DeleteCopyMoveProductListingInput!) {
        deleteProductListing(input: $input) {
            listingId
            type
            submissionStatus
        }
    }
`
